import {
  createScrollbar,
  getUpdateScrollbarHandler,
  setupDragHandler,
} from "../common/custom-scrollbar";

function howToMenuScrollbar() {
  const container = document.querySelector(".how-to-menu__links");

  if (container) {
    const { scrollbar, scrollbarTrack } = createScrollbar(container, {
      wrapperClass: "how-to-menu__links-wrapper",
      trackClass: "scrollbar-track",
      thumbClass: "custom-scrollbar",
    });

    const updateScrollbar = getUpdateScrollbarHandler(
      container,
      scrollbar,
      scrollbarTrack,
    );

    container.addEventListener("scroll", updateScrollbar);
    window.addEventListener("resize", updateScrollbar);
    setTimeout(updateScrollbar, 100);

    setupDragHandler(container, scrollbar);
  }
}

export default howToMenuScrollbar;